import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function ErrorMessage({msg})
{
    return (
        <p className="error-msg"><FontAwesomeIcon icon={faCircleExclamation}/> {msg}</p>
    )
}
